<template>
  <div class="lib__panel">
    <header class="lib__panel__header">
      <h3 class="lib__h3">{{ $t('contact.person') }}</h3>
    </header>
    <button @click.prevent="remove" class="lib__panel__close">
      <i class="far fa-trash-alt"></i>
    </button>
    <div class="lib__panel__main lib__panel__main--form">
      
      <div class="row civilityRow" v-if="showCivility">
        <civility-selector :data-vv-as="$t('contact.form.civility')" name="civility"
          v-model="value.civility"></civility-selector>
      </div>

      <div class="row">
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.firstname')" required v-model="value.firstname"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.lastname')" required v-model="value.lastname"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.email')" email required v-model="value.email"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <text-box :label="$t('contact.form.job')" required v-model="value.job"></text-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <phone-box :label="$t('contact.form.phone')" :required="!value.mobile || value.mobile === '+32 '"
            v-model="value.phone"></phone-box>
        </div>
        <div class="col-xs-12 col-md-6">
          <phone-box :label="$t('contact.form.mobile')" :required="!value.phone || value.phone === '+32 '" gsm
            v-model="value.mobile"></phone-box>
        </div>
        <div class="col-xs-12" v-if='showSendOfferCopy'>
          <check-box :label="$t('contact.sendOfferCopy')" v-model="value.sendOfferCopy"></check-box>
        </div>
        <div class="col-xs-12">
          <address-form :value="value.address"></address-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { idGenerator } from '@/services'
import AddressForm from '@/components/inputs/Contact/AddressForm.vue'
import { ContactPerson } from '@/models'

@Component({
  name: 'contacterson-form',
  components: {
    AddressForm,
  }
})
export default class ContactPersonForm extends Vue {

  //#region [Property]
  @Prop({ type: Object, required: true }) public readonly value!: ContactPerson
  @Prop({ type: Boolean, required: false, default: true }) public readonly showSendOfferCopy!: boolean
  @Prop({ type: Boolean, required: false, default: false }) public readonly showCivility!: boolean
  //#endregion

  //#region [Data]
  public fieldId: string = idGenerator.getId()
  //#endregion

  //#region [Emit]
  @Emit('remove')
  public remove(): void {
    return undefined
  }
  //#endregion
}
</script>

<style scoped>
.civilityRow {
  padding: 0 10px
}</style>